export enum Status {
    ACTIVE = 'active',
    PENDING = 'pending',
    INACTIVE = 'inactive',
}
